"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Transport_1 = require("./Transport");
var Request_1 = require("../Request");
var openPopup = function (url) {
    var width = 400;
    var height = window.screen.height;
    var left = 0;
    var top = 0;
    return window.open(url, "inspector:popup", "left=" + left + ",top=" + top + ",width=" + width + ",height=" + height + ",resizable,scrollbars=yes,status=1");
};
var PostMessageTransport = /** @class */ (function (_super) {
    __extends(PostMessageTransport, _super);
    function PostMessageTransport(uri) {
        var _this = _super.call(this) || this;
        _this.messageHandler = function (ev) {
            _this.transportRequestManager.resolveResponse(JSON.stringify(ev.data));
        };
        _this.uri = uri;
        _this.postMessageID = "post-message-transport-" + Math.random();
        return _this;
    }
    PostMessageTransport.prototype.createWindow = function (uri) {
        return new Promise(function (resolve, reject) {
            var frame;
            frame = openPopup(uri);
            setTimeout(function () {
                resolve(frame);
            }, 3000);
        });
    };
    PostMessageTransport.prototype.connect = function () {
        var _this = this;
        var urlRegex = /^(http|https):\/\/.*$/;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!urlRegex.test(this.uri)) {
                            reject(new Error("Bad URI"));
                        }
                        _a = this;
                        return [4 /*yield*/, this.createWindow(this.uri)];
                    case 1:
                        _a.frame = _b.sent();
                        window.addEventListener("message", this.messageHandler);
                        resolve();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    PostMessageTransport.prototype.sendData = function (data, timeout) {
        if (timeout === void 0) { timeout = 5000; }
        return __awaiter(this, void 0, void 0, function () {
            var prom, notifications;
            return __generator(this, function (_a) {
                prom = this.transportRequestManager.addRequest(data, null);
                notifications = Request_1.getNotifications(data);
                if (this.frame) {
                    this.frame.postMessage(data.request, this.uri);
                    this.transportRequestManager.settlePendingRequest(notifications);
                }
                return [2 /*return*/, prom];
            });
        });
    };
    PostMessageTransport.prototype.close = function () {
        if (this.frame) {
            window.removeEventListener("message", this.messageHandler);
            this.frame.close();
        }
    };
    return PostMessageTransport;
}(Transport_1.Transport));
exports.default = PostMessageTransport;
